import { toBase64 } from '../../../../utils/index.js';
import { BaseWasmQuery } from '../../BaseWasmQuery.js';
export class QueryAllRoutes extends BaseWasmQuery {
    toPayload() {
        return toBase64({ get_all_routes: {} });
    }
}
